<template>
  <div class="wrapper">
       <div>
         <el-table size="mini"  :data="resultData">
              <el-table-column
                :show-overflow-tooltip="true"
                :label="$t('other.a1374')"
                width="100"
              >
                <template slot-scope="props">
                  <span>{{props.row.product_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('other.a3089')"
              >
                <template  slot-scope="props">
                  <span>
                    <i v-show="props.row.success" class="iconfont icon-gouSolid-copy"></i>
                    <i v-show="!props.row.success" class="iconfont icon-cha1"></i>
                    <span style="color:red">{{props.row.message}}</span>
                  </span>
                </template>

              </el-table-column>
            </el-table>
       </div>
  </div>
</template>

<script>
export default {
data(){
return{
    resultData1:[]
  
}
},
props:{
    resultData: {
      type: Array,
      default: () => {}
    }
},
created(){

},
methods:{

}
}

</script>
<style lang="scss" scoped>
.wrapper{
    margin-top:15px ;

    .icon-gouSolid-copy{
        color: rgb(42, 165, 21);
    }

    .icon-cha1{
        color: rgb(216, 30, 6);
    }
}
</style>